<template>

    <tr v-if="o === n" v-show="!(o===n && o==='' && currentDict.length === 1)">
        <td style="padding: 0 5px;"></td>
        <td style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td width="100%">
                        <v-select
                            v-model="res"
                            :disabled="disabled"
                            :options='[
                                ...currentDict.map(({text, value}) => {
                                    return {
                                        text,
                                        value
                                    }
                                })
                            ]'
                        ></v-select>
                    </td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td style="padding: 0 5px;"></td>
    </tr>
    <tr v-else>
        <td :class="{'selected': res === o}" style="padding: 0 5px;">
            <a @click="res = o">
                {{ (currentDict.find(item => item.value === '' + o) || {text: ''}).text }}
                <i v-if="!((currentDict.find(item => item.value === '' + o) || {text: ''}).text)">✕</i>
            </a>
        </td>
        <td class="selected" style="padding: 0 5px;">
            <table style="width: 100%">
                <tr>
                    <td valign="top"><div v-if="prefix !== ''" width="80" :tooltip="prefix">{{ prefix }}:</div></td>
                    <td width="100%">
                        <v-select
                            v-model="res"
                            :disabled="disabled"
                            :options='[
                                ...currentDict.map(({text, value}) => {
                                    return {
                                        text,
                                        value
                                    }
                                })
                            ]'
                        ></v-select>
                    </td>
                    <td valign="top">{{ suffix }}</td>
                </tr>
            </table>
        </td>
        <td :class="{'selected': res === n}" style="padding: 0 5px;">
            <a @click="res = n">
                {{ (currentDict.find(item => item.value === '' + n) || {text: ''}).text }}
                <i v-if="!((currentDict.find(item => item.value === '' + n) || {text: ''}).text)">✕</i>
            </a>
        </td>
    </tr>
</template>
<script>
import Base from "../Base.vue";
import StrPropsFNO from "../StrPropsFNO.vue";

export default {
    mixins: [Base, StrPropsFNO],
    data() {
        return {
            suffix: this.params.suffix ?? '',
            prefix: this.params.prefix ?? '',
        }
    },
    methods: {
        filterFunc(item) {
            let key = Object.keys(this.filter)[0];
            return item[key] === this.filter[key];
        }
    },
    computed: {
        currentDict() {
            let dict = this.getDict(this.storedItem);

            if (Object.keys(this.filter).length > 0) {
                dict = dict.filter(this.filterFunc);
            }
            dict.unshift({value:'', text: "\u00a0"})
            return dict;
        }
    }
}
</script>
